import React, { useEffect, useState } from "react";
import DefaultSettingComponent from "../../../Components/AdminComponent/DefaultSettingComponent/DefaultSettingComponent";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import { Apiurl, GetLocalStorageParsed, parseData } from "../../utils/page";
import axios from "axios";
import AdminHeader from "../../../Components/AdminComponent/AdminHeader/AdminHeader";
import AdminSidebar from "../../../Components/AdminComponent/AdminSidebar/AdminSidebar";
import { toast } from "react-toastify";

const DefaultSetting = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [defaultSettingData, setDefaultSettingData] = useState();

  const [formData, setFormData] = useState({
    DefaultVendorReceivedMoney: "",
    PromotionalBannerImpressionCharges: "",
    DefaultUserReceivedMoney: "",
    OnShowInterestByUserPoint: "",
    DefaultWinnerDeclareDayonEveryWeek: "",
    DefaultConvertVendorPointsInMoney: "",
    PointRangeFrom: "",
    PointRangeTo: "",
    DeductionPerBannerView: "",
    RewardsPointToUser: "",
    RewardsPointToReferralUser: "",
    VendorCreationBonus: "",
    BonusBannerImpression: "",
    MinimumPurchaseAmountForCoupon: "",
    MinimumPurchaseAmountForDefaultGiftOfSpecialOffer: "",
    CouponAmount: "",
    DeliveryCharges: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    DefaultVendorReceivedMoney: "",
    DefaultUserReceivedMoney: "",
    PointRangeFrom: "",
    PointRangeTo: "",
    DefaultConvertVendorPointsInMoney: "",
    RewardsPointToReferralUser: "",
    RewardsPointToUser: "",
    DeductionPerBannerView: "",
    VendorCreationBonus: "",
    BonusBannerImpression: "",
    PromotionalBannerImpressionCharges: "",
    MinimumPurchaseAmountForCoupon: "",
    MinimumPurchaseAmountForDefaultGiftOfSpecialOffer: "",
    DeliveryCharges: "",
  });
  const validations = () => {
    const errors = {};
    if (
      !formData?.DefaultVendorReceivedMoney 
    ) {
      errors.DefaultVendorReceivedMoney =
        "Please enter Default Vendor Received Money";
    }
    if (
      !formData?.DefaultUserReceivedMoney 
    ) {
      errors.DefaultUserReceivedMoney =
        "Please enter Default User Received Money";
    }
    if (!formData?.PointRangeFrom ) {
      errors.PointRangeFrom =
        "Please enter Default User Received Lucky Points From";
    }

    if (!formData?.PointRangeTo ) {
      errors.PointRangeTo =
        "Please enter Default User Received Lucky Points To";
    }
    if (
      !formData?.DefaultConvertVendorPointsInMoney 
    ) {
      errors.DefaultConvertVendorPointsInMoney =
        "Please enter Default Convert Affiliate Partner Points In Money";
    }

    if (
      !formData?.RewardsPointToReferralUser 
    ) {
      errors.RewardsPointToReferralUser =
        "Please enter Default User Received Point From Refer";
    }
    if (
      !formData?.RewardsPointToUser
    ) {
      errors.RewardsPointToUser =
        "Please enter Default User Received Point From Refer Claim";
    }
    if (
      !formData?.DeductionPerBannerView 
    ) {
      errors.DeductionPerBannerView =
        "Please enter Charges For Per View On Banner";
    }

    if (
      !formData?.VendorCreationBonus 
    ) {
      errors.VendorCreationBonus =
        " Please enter Affiliate Partner Point Bonus ";
    }
    if (
      !formData?.BonusBannerImpression 
    ) {
      errors.BonusBannerImpression =
        " Please enter Bonus Impression While Adding Banner ";
    }
    if (
      !formData?.PromotionalBannerImpressionCharges
    ) {
      errors.PromotionalBannerImpressionCharges =
        " Please enter Promotional Banner Impression Charges ";
    }

    if (
      !formData?.MinimumPurchaseAmountForCoupon 
    ) {
      errors.MinimumPurchaseAmountForCoupon =
        " Please enter Minimum Purchase Amount For Getting Coupon For Special Offer";
    }
    if (
      !formData?.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer
    ) {
      errors.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer =
        " Please enter Minimum Purchase Amount For Default Gift Of SpecialOffer";
    }

    if (
      !formData?.DeliveryCharges 
    ) {
      errors.DeliveryCharges = " Please enter Delivery charges";
    }

    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      return false;
    }

    // If no errors, clear the error messages and return true
    setErrorMessage({
      DefaultVendorReceivedMoney: "",
      DefaultUserReceivedMoney: "",
      PointRangeFrom: "",
      PointRangeTo: "",
      DefaultConvertVendorPointsInMoney: "",
      RewardsPointToReferralUser: "",
      RewardsPointToUser: "",
      DeductionPerBannerView: "",
      VendorCreationBonus: "",
      BonusBannerImpression: "",
      PromotionalBannerImpressionCharges: "",
      MinimumPurchaseAmountForCoupon: "",
      MinimumPurchaseAmountForDefaultGiftOfSpecialOffer: "",
      DeliveryCharges: "",
    });
    return true;
  };
  const getDefaultSetting = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/SuperAdmin/GetDefaultSetting`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setDefaultSettingData(data?.[0]);
        setFormData({
          ...formData,
          DefaultVendorReceivedMoney: data?.[0]?.DefaultVendorReceivedMoney,
          PromotionalBannerImpressionCharges:
            data?.[0]?.PromotionalBannerImpressionCharges,
          DefaultUserReceivedMoney: data?.[0]?.DefaultUserReceivedMoney,
          OnShowInterestByUserPoint: data?.[0]?.OnShowInterestByUserPoint,
          DefaultWinnerDeclareDayonEveryWeek:
            data?.[0]?.DefaultWinnerDeclareDayonEveryWeek,
          DefaultConvertVendorPointsInMoney:
            data?.[0]?.DefaultConvertVendorPointsInMoney,
          PointRangeFrom: data?.[0]?.PointRangeFrom,
          PointRangeTo: data?.[0]?.PointRangeTo,
          DeductionPerBannerView: data?.[0]?.DeductionPerBannerView,
          RewardsPointToUser: data?.[0]?.RewardsPointToUser,
          RewardsPointToReferralUser: data?.[0]?.RewardsPointToReferralUser,
          VendorCreationBonus: data?.[0]?.VendorCreationBonus,
          BonusBannerImpression: data?.[0]?.BonusBannerImpression,
          MinimumPurchaseAmountForCoupon:
            data?.[0]?.MinimumPurchaseAmountForCoupon,
          MinimumPurchaseAmountForDefaultGiftOfSpecialOffer:
            data?.[0]?.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer,
          CouponAmount: data?.[0]?.CouponAmount,
          DeliveryCharges: data?.[0]?.DeliveryCharges,
        });
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getDefaultSetting();
  }, []);

  const handleUpdateSetting = () => {
    if (!validations()) return;
    const data = {
      id: defaultSettingData?.Id,
      defaultVendorReceivedMoney: formData?.DefaultVendorReceivedMoney,
      promotionalBannerImpressionCharges:
        formData?.PromotionalBannerImpressionCharges,
      defaultUserReceivedMoney: formData?.DefaultUserReceivedMoney,
      onShowInterestByUserPoint: formData?.OnShowInterestByUserPoint,
      defaultWinnerDeclareDayonEveryWeek:
        formData?.DefaultWinnerDeclareDayonEveryWeek,
      defaultConvertVendorPointsInMoney:
        formData?.DefaultConvertVendorPointsInMoney,
      pointRangeFrom: formData?.PointRangeFrom,
      pointRangeTo: formData?.PointRangeTo,
      deductionPerBannerView: formData?.DeductionPerBannerView,
      rewardsPointToUser: formData?.RewardsPointToUser,
      rewardsPointToReferralUser: formData?.RewardsPointToReferralUser,
      vendorCreationBonus: formData?.VendorCreationBonus,
      bonusBannerImpression: formData?.BonusBannerImpression,
      minimumPurchaseAmountForCoupon: formData?.MinimumPurchaseAmountForCoupon,
      minimumPurchaseAmountForDefaultGiftOfSpecialOffer:
        formData?.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer,
      couponAmount: formData?.CouponAmount,
      deliveryCharges: formData?.DeliveryCharges,
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/SuperAdmin/UpdateDefaultSetting`,
    };
    axios(option)
      .then((e) => {

          if (e?.data?.status === "OK") {
                  toast.success(e?.data?.message);
                }
                if (e?.data?.status === "BadRequest") {
                    toast.error(e?.data?.message);
                  }
      })
      .catch((error) => {});
  };
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <AdminHeader />
      <div className="row col-lg-12">
        <AdminSidebar />
        <div className="col-lg-10 right_content">
          <DefaultSettingComponent
            handleUpdateSetting={handleUpdateSetting}
            setFormData={setFormData}
            formData={formData}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      </div>
    </div>
  );
};
export default DefaultSetting;
